var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgVideoPauseIcon = function SvgVideoPauseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon ionic-ios-pause",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 591",
    d: "M14.756 32.701H9.267a.668.668 0 01-.7-.635V7.933a.668.668 0 01.7-.635h5.492a.668.668 0 01.7.635v24.133a.668.668 0 01-.703.635z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 592",
    d: "M30.736 32.701h-5.492a.668.668 0 01-.7-.635V7.933a.668.668 0 01.7-.635h5.492a.668.668 0 01.7.635v24.133a.668.668 0 01-.7.635z"
  }))));
};
export default SvgVideoPauseIcon;